document.addEventListener('click', (event) => {
  const tabButton = event.target.closest('[data-imp-tab-target]');
  if (!tabButton) return;

  const container = tabButton.closest('[data-imp-pdp-tabs]');
  if (!container) return;

  const targetId = tabButton.getAttribute('data-imp-tab-target');

  container.querySelectorAll('[data-imp-tab-target]').forEach((button) => {
    const isActive = button === tabButton;
    button.classList.toggle('is-active', isActive);
    button.setAttribute('aria-selected', isActive);
  });

  container.querySelectorAll('[data-imp-tab-panel]').forEach((panel) => {
    panel.hidden = panel.id !== targetId;
  });
});
